import Viz from 'viz.js';
import { Module, render } from 'viz.js/full.render.js';
import convertRough from '../convertRough';

export default async (input, options = {}) => {
  // viz instance
  const viz = new Viz({ Module, render });
  const svg = await viz.renderSVGElement(input);
  return convertRough(svg, options);
};
